import { SuperAdminPage } from "./super-admin-v5/SuperAdminPage";

export default function TenantSettingsPage() {
  return <SuperAdminPage />;
}
